import { logErrorWithTags } from 'src/shared/telemetry/logger';

export const useOnboardingError = () => {
  const logError = (error: Error) => {
    logErrorWithTags(error, { featureName: 'onboarding' });
  };

  return { logError };
};
